import * as types from './acttionsTypes';

export function replaceCarouselData(index){
    return{
        type:types.REPLACE_CAROUSEL_DATA,
        index
    }
}


// WEBPACK FOOTER //
// ./src/actions/replaceCarouselData.js